import type {RootState} from "../../Store/index.js";

export const OnStoreLoaded_listeners = [] as ((store: RootState)=>any)[];
export function OnStoreLoaded(listener: (store: RootState)=>any) { OnStoreLoaded_listeners.push(listener); }
export let OnStoreLoaded_called = false;
export function OnStoreLoaded_Trigger(store: RootState) {
	OnStoreLoaded_listeners.forEach(a=>a(store));
	OnStoreLoaded_called = true;
}

// these are called once, at start of first session (used eg. for delaying certain log-capture until then)
export const OnFirstSessionStart_listeners = [] as (()=>any)[];
export function OnFirstSessionStart(listener: ()=>any) { OnFirstSessionStart_listeners.push(listener); }
let OnFirstSessionStart_fired = false;
export function OnFirstSessionStart_TriggerCheck() {
	if (OnFirstSessionStart_fired) return;
	OnFirstSessionStart_fired = true;
	OnFirstSessionStart_listeners.forEach(a=>a());
}